import { render, staticRenderFns } from "./allinpay_bind_phone.vue?vue&type=template&id=478cad60&scoped=true"
import script from "./allinpay_bind_phone.vue?vue&type=script&lang=js"
export * from "./allinpay_bind_phone.vue?vue&type=script&lang=js"
import style0 from "./allinpay_bind_phone.vue?vue&type=style&index=0&id=478cad60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478cad60",
  null
  
)

export default component.exports